import { render, staticRenderFns } from "./inboxrightclick.vue?vue&type=template&id=7915b2f1&"
import script from "./inboxrightclick.vue?vue&type=script&lang=js&"
export * from "./inboxrightclick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports